import axios from '../../api/axios-configure'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Heading,Button } from 'monday-ui-react-core'
import { StatementContext } from 'utils/context/StatementsContext'
import { useSearchParams } from 'react-router-dom'

const ReportHeader = ({isProductBalancing }) => {
    const {
        currentSenderCompanyName,
        setCurrentSenderCompanyName
    } = useContext(StatementContext)

    const [params] = useSearchParams()

    const reportTitle = useMemo(() => {
        if (!isProductBalancing)
            return "Payout Statements"
        else
            return "Gas Balancing Statements"
     }, [isProductBalancing])

    const [headerTitle, setHeaderTitle] = useState(reportTitle)

    useEffect(() => {
        const setCompanyName = () => {
            const searchParamsObj = Object.fromEntries([...params])
            const { senderNumber } = searchParamsObj
    
            if (!senderNumber) {
                setHeaderTitle(reportTitle)
                return;
            }
    
            axios
                .get(`/GetCompanyNameBySenderNumber?senderNumber=${senderNumber}`)
                .then(response => {
                    setCurrentSenderCompanyName(response.data)
                    setHeaderTitle(`${reportTitle} - ${response.data}`)
                })
                .catch(err => console.error(err))
        }

        if (!currentSenderCompanyName) {
            setCompanyName()
        } else {
            setHeaderTitle(`${reportTitle} - ${currentSenderCompanyName}`)
        }
    }, [currentSenderCompanyName, params])

    return (
        <section className="d-flex justify-content-between">
            <Heading
                ellipsis={false}
                className="d-flex mb-0"
                value={headerTitle}
            />
        </section>
    )
}

export default ReportHeader
